import styled from 'styled-components';

export const OnscrollShow = styled.div`

    display: none;
    align-items: center; 
    column-gap: 15px;
  

    @media screen and (max-width:1440px) {
        column-gap: 6px;
     }
  @media screen and (max-width:1024px) {
         display:flex;  
         justify-content: end;
         column-gap: 0px; 
         width: 101%;    
    }  
     
    @media screen and (max-width:991px) {
         column-gap: 0px;
         justify-content: end;
          width: 102%;  
     }
 @media screen and (max-width:767px) {
         column-gap: 0px;
         justify-content: center;
     }
 .css-13cymwt-control {
    border: none;
      white-space: nowrap;
}
.css-b62m3t-container {
    position: relative;
    box-sizing: border-box;
    max-width: 163px;
    margin-left: 5px;
    margin-right: 6px;
}
    .css-1jqq78o-placeholder {
    white-space: nowrap;
    padding: 0 !important;
    font-family: "Jost", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
     color:#333;
     width: 95px;
}
.css-1jqq78o-placeholder:focus-visible {
    border:none;
   box-shadow:none;
   outline: none;
   
 }
.css-1xc3v61-indicatorContainer {
    display: none;
}
.css-tj5bde-Svg{
      display: none;
}

 .css-1hb7zxy-IndicatorsContainer {
    display: none;
}
 .css-t3ipsp-control{
        border:none!important;
        box-shadow:none !important;
        outline: none !important;
        padding:0 !important;
    }
.css-1wy0on6 {
    display: none;
}
 .css-1nmdiq5-menu{
   width:240px !important; 
   z-index:9 !important;
 }
   .css-166bipr-Input{
   width:100px !important; 
}
   .css-hlgwow{
     width:150px;
   }

`;

export const SerchBlock = styled.div`
    .search-header{ 
        display: flex;
        align-items: center;
        background: #fff;
        box-shadow: 0px 20px 20px #0000001A;
        border-radius: 10px;
        padding: 4px 4px;
        max-width: 300px;
        width: 100%;
        @media screen and (max-width:1440px) {
            max-width: 262px;
        }
             @media screen and (max-width:1366px) {
            max-width: 241px;
            margin-left: 5px;
        }
        @media screen and (max-width:1280px) {
            max-width: 200px;
        } 
        @media screen and (max-width:1200px) {
                  max-width: 304px;
        }
        @media screen and (max-width:1024px) {
           max-width: 304px;
               margin: 0;
        }
              @media screen and (max-width:767px) {
                      max-width: 282px;
                      margin: 0 auto;
        }
            .zip-code-heder{
              &::-webkit-input-placeholder { 
                color: #000 !important;
                opacity: 1;
                }
               &::-moz-placeholder { 
                color: #000 !important;
                opacity: 1;
                }
               &:-ms-input-placeholder { 
                color: #000 !important;
                opacity: 1;
                }
               &:-moz-placeholder { 
                color: #000 !important;
                opacity: 1;
                }
            }
        .form-control{
            border: none;
            padding-top: 2px;
                padding-bottom: 2px;
                font-family: "Jost", sans-serif;
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;

            &:nth-child(2){
                border-left: 1px solid #333333;
                border-radius: 0;
                width: 60%;
            }
        }
        .btn-outline-success{
            order: -1;
            background: #F9DC70;
            border: none;
            border-radius: 7px;
            padding: 6px;
            width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;

        }
    }
  .css-13cymwt-control {
    border: none;
      white-space: nowrap;
}
.css-b62m3t-container { 
    position: relative;
    box-sizing: border-box;
    max-width:130px;
    margin-left: 5px;
    margin-right: 6px;
}
    .css-1jqq78o-placeholder {
    white-space: nowrap;
    padding: 0 !important;
    font-family: "Jost", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    width: 95px;
    color:#333;
}
    div#react-select-5-placeholder {   
    white-space: nowrap;
}
    
.css-1jqq78o-placeholder:focus-visible {
    border:none;
   box-shadow:none;
   outline: none;
   
 }
.css-1xc3v61-indicatorContainer {
    display: none;
}
.css-tj5bde-Svg{
      display: none;
}

 .css-1hb7zxy-IndicatorsContainer {
    display: none;
}
 .css-t3ipsp-control{
        border:none!important;
        box-shadow:none !important;
        outline: none !important;
        padding:0 !important;
    }
.css-15lsz6c-indicatorContainer{
    display:none !important;
 }       
`;

export const OnscrollHide = styled.div`
    display: flex;
    align-items: center;
    column-gap: 15px;

    a.nav-link {
        font-family: "Jost", sans-serif;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        color: #FFFFFF;
        padding: 0;

        &:nth-child(2){
            border-left: 1px solid #fff;
            padding-left: 15px !important;
        }
    }
    // .search-show-in-inner-page{
    //     display: none;
      

    // }
.desktop-blog.nav-link {
   display: block;
    @media screen and (max-width:1024px) {
                display: none;
    }
}
 
.bag-img {
    @media screen and (max-width:1024px) {
        position: absolute;
        top: -34px;
        right: 47px;

    }
         @media screen and (max-width:991px) {
             top: 28px;

          }
  
         @media screen and (max-width:767px) {
             top: 24px;

          }
  
}
 span.dcart-items {
    border-radius: 50% !important;
    border: 1px solid #F9DC70;
    display: inline-block;
    font-size: 13px;
    font-weight: 500;
    height: 18px;
    line-height: 18px;
    position: relative;
    right: 10px;
    text-align: center;
    top: -10px;
    width: 18px;
}
`;


export const OnscrollShowScreen = styled.div`


`;